import { createFileRoute } from '@tanstack/react-router'
import { parse } from 'valibot'

import { fetchItemUnit } from '@/features/itemUnits/api'

import { ItemUnitParamsSchema } from '../-models/item-units-params'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/_system-master-settings/item-units/$ItemUnitId'
)({
  parseParams: (params) => parse(ItemUnitParamsSchema, params),
  loader: async ({
    abortController,
    params: { tenantKey, ItemUnitId },
    context: { auth }
  }) => {
    return {
      authUser: auth.user,
      itemUnit: await fetchItemUnit(
        {
          tenantKey,
          itemUnitId: ItemUnitId
        },
        abortController.signal
      )
    }
  },
  meta: ({ loaderData }) => [
    {
      title: loaderData.itemUnit.data.name
    }
  ]
})
